import { useSyncExternalStore } from "react";

// Nothing ever changes after the first client commit, so the subscribe callback is a no-op — the
// snapshot pair alone is what makes this flip.
function subscribe(): () => void {
  return () => {
    // no-op: server-vs-client never changes during a session
  };
}

function getSnapshot(): boolean {
  return false;
}

function getServerSnapshot(): boolean {
  return true;
}

/**
 * `true` while rendering on the server AND during the first (hydrating) client render, `false` from
 * the first post-hydration commit onwards.
 *
 * This is the standard `useSyncExternalStore` server/client split rather than a `typeof window`
 * sniff: hydration must render exactly what the server rendered, or React discards the server HTML
 * and re-renders from scratch (which would defeat the whole point of emitting it). Returning `true`
 * for the hydrating pass keeps the two trees identical, then the store flips and the client swaps in
 * the real virtualized list.
 *
 * NOTE: on native this is always `false` after mount, and there is no server pass at all, so callers
 * get the normal client behaviour with no extra render.
 */
export function useIsServerRender(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
